(function () {
  'use strict';

  function buildEmbedUrl(type, id) {
    if (type === 'youtube') {
      return 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
    }
    if (type === 'vimeo') {
      return 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1';
    }
    return null;
  }

  function VideoCarousel(root) {
    this.root = root;
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-video-carousel-panel]'));
    this.prevBtn = root.querySelector('[data-video-carousel-prev]');
    this.nextBtn = root.querySelector('[data-video-carousel-next]');
    this.currentIndex = 0;

    if (!this.panels.length) return;

    this.bindPosters();
    this.bindArrows();
  }

  VideoCarousel.prototype.bindPosters = function () {
    this.panels.forEach(function (panel) {
      var trigger = panel.querySelector('[data-video-carousel-trigger]');
      var embedWrap = panel.querySelector('[data-video-carousel-embed]');
      if (!trigger || !embedWrap) return;

      trigger.addEventListener('click', function () {
        var type = panel.getAttribute('data-video-type');
        var id = panel.getAttribute('data-video-id');
        var src = buildEmbedUrl(type, id);
        if (!src) return;

        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', src);
        iframe.setAttribute('title', 'Video');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('frameborder', '0');

        embedWrap.innerHTML = '';
        embedWrap.appendChild(iframe);
        embedWrap.hidden = false;
        trigger.hidden = true;
      });
    });
  };

  VideoCarousel.prototype.stopPanel = function (panel) {
    var trigger = panel.querySelector('[data-video-carousel-trigger]');
    var embedWrap = panel.querySelector('[data-video-carousel-embed]');
    if (embedWrap) {
      embedWrap.innerHTML = '';
      embedWrap.hidden = true;
    }
    if (trigger) trigger.hidden = false;
  };

  VideoCarousel.prototype.bindArrows = function () {
    var self = this;
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.goTo(self.currentIndex - 1);
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.goTo(self.currentIndex + 1);
      });
    }
  };

  VideoCarousel.prototype.goTo = function (index) {
    var nextIndex = (index + this.panels.length) % this.panels.length;
    if (nextIndex === this.currentIndex) return;

    this.stopPanel(this.panels[this.currentIndex]);
    this.panels[this.currentIndex].classList.remove('is-active');
    this.panels[nextIndex].classList.add('is-active');
    this.currentIndex = nextIndex;
  };

  function init(scope) {
    scope.querySelectorAll('[data-video-carousel]').forEach(function (root) {
      if (root.videoCarouselInstance) return;
      root.videoCarouselInstance = new VideoCarousel(root);
    });
  }

  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();